import React from 'react';
import Header from '../Header';
import Footer from '../Footer';
import HeaderSection from './HeaderSection';
import OpsHeadSection from './OpsHeadSection';
import TherapistSection from './TherapistSection';
import ComplianceSection from './ComplianceSection';
import OfflineModeSection from './OfflineModeSection';
import PayoutCalculationSection from './PayoutCalculationSection';
import WhatChangesSection from './WhatChangesSection';
import GettingStartedSection from './GettingStartedSection';

const PlatformPage = () => {
    return (
        <>
            <Header />
            <HeaderSection />
            <OpsHeadSection />
            <TherapistSection />
            <ComplianceSection />
            <OfflineModeSection />
            <PayoutCalculationSection />
            <WhatChangesSection />
            <GettingStartedSection />
            <Footer />
        </>
    );
};

export default PlatformPage;
